export default __webpack_public_path__ + "static/media/Multiplication_02.29aee8ab.png";